// extracted by mini-css-extract-plugin
export default {"menu":"AdvertPanelMenu_menu_AW4KG"};